const router = {
	front: {
		xhr: {
			view: 'front/xhr/view',
			registration: '/front/xhr/registration'
		}
	}
};

export default router;